export default __webpack_public_path__ + "ed5fe5589d79fe89add43744ae41378b.jpg";